class AdminBulkUploadStudentController {
    // @ngInject
    constructor(bulkUploadService, school) {
        this.onBulkUpload = bulkUploadService.createTeacherAccountsInBulk;
        this.school = school;
    }
}

export default AdminBulkUploadStudentController;
